import { render, staticRenderFns } from "./bgiRegistnoAction.vue?vue&type=template&id=f5e71a90&scoped=true"
import script from "./bgiRegistnoAction.vue?vue&type=script&lang=js"
export * from "./bgiRegistnoAction.vue?vue&type=script&lang=js"
import style0 from "./bgiRegistnoAction.vue?vue&type=style&index=0&id=f5e71a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e71a90",
  null
  
)

export default component.exports